import { cn } from '@/ui/utils';
import { Collapsible as CollapsiblePrimitive } from '@base-ui/react/collapsible';
import { ArrowDownIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';

function Collapsible({
  className,
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Root>) {
  return (
    <CollapsiblePrimitive.Root
      className={cn('flex w-full flex-col justify-center', className)}
      {...props}
    />
  );
}

function CollapsibleTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Trigger>) {
  return (
    <CollapsiblePrimitive.Trigger
      className={cn('group flex cursor-pointer items-center gap-1.5', className)}
      {...props}
    >
      {children}
    </CollapsiblePrimitive.Trigger>
  );
}

function CollapsibleTriggerIcon({
  className,
  ...props
}: Omit<React.ComponentProps<typeof Icon>, 'icon'>) {
  return (
    <Icon
      className={cn('size-3.5 shrink-0 group-data-panel-open:rotate-180', className)}
      icon={ArrowDownIcon}
      {...props}
    />
  );
}

function CollapsiblePanel({
  className,
  children,
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Panel>) {
  return (
    <CollapsiblePrimitive.Panel className={cn('w-full', className)} {...props}>
      {children}
    </CollapsiblePrimitive.Panel>
  );
}

export { Collapsible, CollapsibleTrigger, CollapsibleTriggerIcon, CollapsiblePanel };
